export class UserAddRequest {
       // userId: string;
	  	address1: string;
		address2: string;
		batches: [] = [];

		city: string;
		clients: [] = [];

		createdBy: string;
		dateOfBirth: Date;
		effectiveDate: string;
		email: string;
		firstName: string;
		lastName: string;
		licensedExpiryDate: string;
		licensedStartDate: string;
		licensedState: string;
		newPassword: string;
		npi: string;
		otpPreference: number;
		password: string;
		phoneNumber: string;
		portals: any[];

		projects: [] = [];
		qaNeeded: string;
		roles: any[] = [];

		serviceAddress1: string;
		serviceAddress2: string;
		serviceCity: string;
		serviceState: string;
		serviceZip: string;

		state: string;
		terminationDate: string;
		timeZone: number;
		title        : string;
		updatedBy: string;
		userId:number;
		zip:string;

    }
